export default __webpack_public_path__ + "static/media/zapqbanner.45cd265e.jpg";